import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Domain, Workspace } from "../../../path";
import usePost from "../../../Hooks/usePost";
import { toast } from "react-toastify";
import { Set_Loader } from "../../../Redux/Action/LoaderAction";
import { useDispatch } from "react-redux";

const Button = ({ ClassDetails, Get_ClassDetails, Get_otherClassDetails }) => {
  const { school_id, class_id } = useParams();
  const Dispatch = useDispatch();
  const Navigate = useNavigate();
  const StartEvaluation_Handler = () => {
    Navigate(
      `/evaluation/${school_id}/${
        atob(class_id) == "other"
          ? school_id + "/other/load/load"
          : class_id + "/class/load/load"
      }`
    );
  };

  const InviteParent_Post = usePost(
    `${Workspace[Domain].API_Path}/invite_parents`
  );
  const RemindParent_Post = usePost(
    `${Workspace[Domain].API_Path}/remind_parents`
  );

  const InviteParent = () => {
    if (atob(class_id) != "other") {
      InviteParent_Post.Postcall({
        class_id: atob(class_id),
      });
    } else {
      InviteParent_Post.Postcall({
        school_id: atob(school_id),
      });
    }
  };
  const RemindeParent = () => {
    if (atob(class_id) != "other") {
      RemindParent_Post.Postcall({
        class_id: atob(class_id),
      });
    } else {
      RemindParent_Post.Postcall({
        school_id: atob(school_id),
      });
    }
  };
  useEffect(() => {
    if (InviteParent_Post.Post != null) {
      switch (InviteParent_Post.Post.status) {
        case 200:
          if (atob(class_id) != "other") {
            Get_ClassDetails();
          } else {
            Get_otherClassDetails();
          }
          toast.success("Invite sent successfully");
          toast.clearWaitingQueue();
          break;

        default:
          break;
      }
    }
  }, [InviteParent_Post.Post]);
  useEffect(() => {
    if (RemindParent_Post.Post != null) {
      switch (RemindParent_Post.Post.status) {
        case 200:
          if (atob(class_id) != "other") {
            Get_ClassDetails();
          } else {
            Get_otherClassDetails();
          }
          toast.success("Reminder sent successfully");
          toast.clearWaitingQueue();
          break;

        default:
          break;
      }
    }
  }, [RemindParent_Post.Post]);
  return (
    <div className="flex flex-wrap items-center justify-center max-[700px]:flex-col border-t-2 w-[90%] mx-auto">
      <button
        onClick={StartEvaluation_Handler}
        className={`m-2 bg-[#f78800] text-[white] px-4 py-2 text-xs font-semibold rounded-md max-[700px]:w-full ${
          !ClassDetails?.is_startevaluation
            ? "opacity-30 pointer-events-none"
            : "opacity-100 pointer-events-auto"
        }`}
      >
        Start evaluation
      </button>
      <button
        onClick={InviteParent}
        className={`m-2 bg-[#f78800] text-[white] px-4 py-2 text-xs font-semibold rounded-md max-[700px]:w-full ${
          !ClassDetails?.is_invite_parent
            ? "opacity-30 pointer-events-none"
            : "opacity-100 pointer-events-auto"
        }`}
      >
        Invite parents
      </button>
      <button
        onClick={RemindeParent}
        className={`m-2 bg-[#f78800] text-[white] px-4 py-2 text-xs font-semibold rounded-md max-[700px]:w-full ${
          !ClassDetails?.is_remind
            ? "opacity-30 pointer-events-none"
            : "opacity-100 pointer-events-auto"
        }`}
      >
        Remind parents
      </button>
      <a
        href={ClassDetails?.download_report}
        className={`m-2 bg-[#f78800] text-center text-[white] px-4 py-2 text-xs font-semibold rounded-md max-[700px]:w-full ${
          ClassDetails?.download_report == ""
            ? "opacity-30 pointer-events-none"
            : "opacity-100 pointer-events-auto"
        }`}
      >
        Download report
      </a>
    </div>
  );
};

export default Button;
